import {TryGetValue, TrySetValue} from "./local-storage";

const DebugStateStorageKey = 'TronEditorDebugger-IsDebugging';

class TronEditorDebugger {
    private IsDebugging: boolean = false;

    constructor() {
        this.startDebugging = this.startDebugging.bind(this);
        this.stopDebugging = this.stopDebugging.bind(this);
        this.isDebugging = this.isDebugging.bind(this);
        this.log = this.log.bind(this);
        const debugState = TryGetValue(DebugStateStorageKey);
        if (debugState.hasValue) {
            this.IsDebugging = debugState.value === 'true';
        }
    }

    public isDebugging(): boolean {
        return this.IsDebugging;
    }  

    public startDebugging(): string {
        this.IsDebugging = true;
        TrySetValue(DebugStateStorageKey, 'true');

        return '👷 Debugging started - logs will be shown in console. Debugging can be stopped by calling stopDebugging() 👷';
    }
    public stopDebugging(): string {
        this.IsDebugging = false;
        TrySetValue(DebugStateStorageKey, 'false');

        return '👷 Debugging stopped - logs will not be shown in console. Debugging can be re-started by calling startDebugging() 👷';
    }

    public log(message?: any): void {
        if (this.IsDebugging) {
            console.log(message);
        }
    }

    public error(message?: any): void {
        if(this.isDebugging){
            console.error(message);
        }
    }
}

export const DebuggerInstance: TronEditorDebugger = new TronEditorDebugger();
(window as any).Debugger = DebuggerInstance; 



// WEBPACK FOOTER //
// ./src/App/shared/debugger.tsx